import { useEffect } from 'react';
import { useNavigate, useLocation, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import SideBar from '../components/SideBar';
import DashboardLeads from './dashboards/DashboardLeads';
import DashboardDemo from './dashboards/DashboardDemo';
import DashboardNurturing from './dashboards/DashboardNurturing';
import DashboardFirstInstallment from './dashboards/DashboardFirstInstallment';
import DashboardPending from './dashboards/DashboardPending';
import DashboardEnrollemnts from './dashboards/DashboardEnrollemnts';

function HomePage() {
  const navigate = useNavigate();
  const location = useLocation();

  const token = localStorage.getItem('token');
  const email = localStorage.getItem('email');
  const role = localStorage.getItem('role');

  // Auth verification
  useEffect(() => {
    const verifyUser = async () => {
      if (!token) {
        navigate('/login');
        return;
      }

      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/user/check-user`,
          { email, role, token }
        );

        if (!res.data.success) {
          localStorage.clear();
          navigate('/login');
        }
      } catch (error) {
        console.error('User verification failed:', error.message);
        localStorage.clear();
        navigate('/login');
      }
    };

    verifyUser();
  }, [navigate, location.pathname]);

  // Default selection: /user-home → /user-home/dashboard-leads
  useEffect(() => {
    if (location.pathname === '/user-home') {
      navigate('/user-home/dashboard-leads', { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <div className="h-screen w-full bg-[#F4F6FA]">
      <div className="flex h-full">
        {/* Sidebar */}
        <SideBar />

        {/* Main content */}
        <main className="flex-1 p-4 overflow-y-auto sm:p-6 lg:p-8">
          <div className="mx-auto max-w-7xl">
            <Routes>
              <Route path="dashboard-leads" element={<DashboardLeads />} />
              <Route path="dashboard-demo" element={<DashboardDemo />} />
              <Route path="dashboard-nurturing" element={<DashboardNurturing />} />
              <Route path="dashboard-first-installment" element={<DashboardFirstInstallment />} />
              <Route path="dashboard-pending-installments" element={<DashboardPending />} />
              <Route path="dashboard-enrollments" element={<DashboardEnrollemnts />} />

              {/* Fallback routes */}
              <Route path="" element={<Navigate to="dashboard-leads" replace />} />
              <Route path="*" element={<Navigate to="dashboard-leads" replace />} />
            </Routes>
          </div>
        </main>
      </div>
    </div>
  );
}

export default HomePage;
